import type { TFunction } from 'i18next';
import { isApiError } from '@/api';

export function getDocumentErrorMessage(
  error: unknown,
  isDev: boolean,
  t: TFunction
): string {
  if (!isApiError(error)) return t('documents.errors.generic');
  if (isDev) return `[DEV] ${error.status}: ${error.message}`;
  switch (error.status) {
    case 400:
      return t('documents.errors.validation');
    case 403:
      return t('documents.errors.forbidden');
    case 404:
      return t('documents.errors.notFound');
    default:
      return t('documents.errors.generic');
  }
}

export function getDocumentMutationErrorMessage(
  error: unknown,
  t: TFunction
): string {
  console.error('Document Mutation Error', error);

  if (isApiError(error)) {
    if (typeof error.data === 'string' && error.data.trim().length > 0) {
      return error.data;
    }

    if (
      typeof error.data === 'object' &&
      error.data !== null &&
      'message' in error.data &&
      typeof error.data.message === 'string' &&
      error.data.message.trim().length > 0
    ) {
      return error.data.message;
    }
  }

  return getDocumentErrorMessage(error, import.meta.env.DEV, t);
}
